import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { Link } from "react-router-dom";

import moment from "moment";
import { convertFromMilitaryTime } from "utils/convertFromMillitaryTime";

export default function AppointmentHistoryTable({ data }) {
  const formatDate = React.useCallback(
    (date) => moment(date).format("MMM Do YYYY"),
    []
  );

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>S/N</TableCell>
              <TableCell sx={{ fontWeight: "bold" }} align="left">
                Date
              </TableCell>
              <TableCell sx={{ fontWeight: "bold" }} align="left">
                Start Time
              </TableCell>
              <TableCell sx={{ fontWeight: "bold" }} align="left">
                End Time
              </TableCell>

              <TableCell sx={{ fontWeight: "bold" }} align="left">
                Doctor
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, i) => (
              <TableRow
                key={i}
                sx={{
                  "&:nth-of-type(odd)": {
                    backgroundColor: "background.custom",
                  },
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                  {i + 1}
                </TableCell>
                <TableCell
                  scope="row"
                  align="left"
                  sx={{ color: "primary.darkGrey", fontSize: "0.75rem" }}
                >
                  {formatDate(row?.startDateTime) ===
                  formatDate(row?.endDateTime)
                    ? formatDate(row?.startDateTime)
                    : `${formatDate(row?.startDateTime)} - ${formatDate(
                        row?.endDateTime
                      )}`}
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ color: "primary.darkGrey", fontSize: "0.75rem" }}
                >
                  {row?.startTime
                    ? convertFromMilitaryTime(row?.startTime)
                    : moment(new Date(row?.createdAt)).format("HH:mm a")}
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ color: "primary.darkGrey", fontSize: "0.75rem" }}
                >
                  {row?.startTime
                    ? convertFromMilitaryTime(row?.endTime)
                    : moment(new Date(row?.updatedAt)).format("HH:mm a")}
                </TableCell>

                <TableCell
                  align="left"
                  sx={{ color: "primary.darkGrey", fontSize: "0.75rem" }}
                >
                  <Link to={`/home/staff/${row?.doctor?._id}`}>
                    {row?.doctor?.fullName}
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
